package music.jammers.shared.user.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: Long,
    val name: String,
    val email: String,
    val pictureUrl: String,
    val type: UserType,
    val telegram: String,
    val city: String,
) {

    val isAdmin: Boolean =
        type == UserType.ADMIN
}